
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { allProducts } from '../../mocks/products';
import { categories } from '../../mocks/categories';

export default function Products() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('featured');

  const filteredProducts = selectedCategory === 'all' 
    ? allProducts 
    : allProducts.filter(p => p.category === selectedCategory);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0D1B2A' }}>
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
              جميع المنتجات
            </h1>
            <p className="text-lg text-gray-400">
              اكتشف مجموعتنا الكاملة من المنتجات المتنوعة
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-8">
            <aside className="lg:w-64 flex-shrink-0">
              <div className="rounded-2xl p-6 sticky top-32" style={{ backgroundColor: '#1B2D3E' }}>
                <h3 className="text-xl font-bold mb-6 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                  الفئات
                </h3>
                <div className="space-y-2">
                  <button
                    onClick={() => setSelectedCategory('all')}
                    className={`w-full text-right px-4 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer`}
                    style={{ 
                      backgroundColor: selectedCategory === 'all' ? '#D4A84B' : '#0D1B2A',
                      color: selectedCategory === 'all' ? '#0D1B2A' : '#FFFFFF'
                    }}
                  >
                    جميع المنتجات
                  </button>
                  {categories.map((cat) => (
                    <button
                      key={cat.id}
                      onClick={() => setSelectedCategory(cat.slug)}
                      className={`w-full text-right px-4 py-3 rounded-lg transition-colors whitespace-nowrap cursor-pointer`}
                      style={{ 
                        backgroundColor: selectedCategory === cat.slug ? '#D4A84B' : '#0D1B2A',
                        color: selectedCategory === cat.slug ? '#0D1B2A' : '#FFFFFF'
                      }}
                    >
                      {cat.name}
                    </button>
                  ))}
                </div>
              </div>
            </aside>

            <div className="flex-1">
              <div className="flex items-center justify-between mb-8">
                <p className="text-gray-400">
                  عرض {filteredProducts.length} منتج
                </p>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="px-4 py-2 rounded-lg text-sm cursor-pointer text-white"
                  style={{ backgroundColor: '#1B2D3E', border: '1px solid #2D4356' }}
                >
                  <option value="featured">الأكثر مبيعاً</option>
                  <option value="price-low">السعر: من الأقل للأعلى</option>
                  <option value="price-high">السعر: من الأعلى للأقل</option>
                  <option value="rating">الأعلى تقييماً</option>
                </select>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
                {filteredProducts.map((product) => (
                  <Link
                    key={product.id}
                    to={`/product/${product.id}`}
                    className="group cursor-pointer"
                  >
                    <div className="rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300" style={{ backgroundColor: '#1B2D3E' }}>
                      <div className="relative aspect-square w-full h-full overflow-hidden" style={{ backgroundColor: '#0D1B2A' }}>
                        <img 
                          src={product.image}
                          alt={product.name}
                          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                        />
                        {product.discount && (
                          <div className="absolute top-4 right-4 text-black px-3 py-1 rounded-full text-sm font-bold" style={{ backgroundColor: '#D4A84B' }}>
                            -{product.discount}%
                          </div>
                        )}
                      </div>
                      <div className="p-6">
                        <h3 className="text-lg font-bold mb-2 line-clamp-2 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                          {product.name}
                        </h3>
                        <div className="flex items-center gap-2 mb-3">
                          <div className="flex items-center">
                            {[...Array(5)].map((_, i) => (
                              <div key={i} className="w-4 h-4 flex items-center justify-center">
                                <i className={`ri-star-${i < product.rating ? 'fill' : 'line'} text-sm`} style={{ color: '#D4A84B' }}></i>
                              </div>
                            ))}
                          </div>
                          <span className="text-sm text-gray-400">({product.reviews})</span>
                        </div>
                        <div className="flex items-center gap-3">
                          <span className="text-2xl font-bold" style={{ color: '#D4A84B' }}>
                            {product.price} ر.س
                          </span>
                          {product.originalPrice && (
                            <span className="text-lg line-through text-gray-500">
                              {product.originalPrice} ر.س
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
